<template>
  <div>
    <centered-logo-simple-header class="is-hidden-desktop" />
    <div class="split-layout">
      <div class="columns is-desktop is-gapless">
        <div class="column is-three-fifths-desktop is-two-fifths-widescreen">
          <registration-form />
        </div>
        <split-layout-right />
      </div>
    </div>
  </div>
</template>

<script>
import CenteredLogoSimpleHeader from '@/components/CenteredLogoSimpleHeader.vue'
import RegistrationForm from '@/components/RegistrationForm.vue'
import SplitLayoutRight from '@/components/SplitLayoutRight.vue'

export default {
  name: 'PasswordReset',
  components: {
    CenteredLogoSimpleHeader,
    RegistrationForm,
    SplitLayoutRight
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/split_layout.scss';
</style>
